export default __webpack_public_path__ + "static/media/ic_main_1.55e31cce.svg";